import departureActions from './departure/actions';
import destinationActions from './destination/actions';
import datesActions from './dates/actions';

export default {
  ...departureActions,
  ...destinationActions,
  ...datesActions,
};
